import { render, staticRenderFns } from "./DetailsCard.vue?vue&type=template&id=81e5d69c&scoped=true&"
import script from "./DetailsCard.vue?vue&type=script&lang=ts&"
export * from "./DetailsCard.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsCard.vue?vue&type=style&index=0&id=81e5d69c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e5d69c",
  null
  
)

export default component.exports